import { tw } from '@careinfo/tailwind';
import { ColumnDef, type Table } from '@tanstack/react-table';
import moment from 'moment';
import { Dispatch, SetStateAction } from 'react';
import NACell from '../DataTable/NACell';
import TrackingCell from '../DataTable/TrackingCell';

interface Props {
  checkedAllItems: boolean;
  handleSelectAll: (table: Table<any>) => void;
  isSelected: (value: string, order: string) => boolean;
  handleIndividualSelect: (value: string, order: string) => void;
  setSelectedOrder: Dispatch<SetStateAction<string>>;
  setOpenReviewModal: Dispatch<SetStateAction<boolean>>;
}

export const getManifestItemColumn = ({
  checkedAllItems,
  handleSelectAll,
  isSelected,
  handleIndividualSelect,
  setSelectedOrder,
  setOpenReviewModal,
}: Props): ColumnDef<any, any>[] => [
  {
    id: 'select',
    header: ({ table }) => {
      return (
        <input
          type='checkbox'
          checked={checkedAllItems}
          onChange={() => handleSelectAll(table)}
          className={tw`cursor-pointer`}
        />
      );
    },
    cell: ({ row }) => (
      <input
        type='checkbox'
        checked={isSelected(row?.original?.id, row?.original?.order?.id)}
        onChange={() =>
          handleIndividualSelect(row?.original?.id, row?.original?.order?.id)
        }
        className={tw`cursor-pointer`}
      />
    ),
  },
  {
    header: 'Date',
    accessorKey: 'order.created',
    cell: ({ cell: { getValue } }) => {
      return (
        <>
          {getValue() ? (
            <p className={tw`whitespace-nowrap`}>
              {moment(getValue()).format('YY-MM-DD HH:mm:ss')}
            </p>
          ) : (
            'N/A'
          )}
        </>
      );
    },
  },
  {
    header: 'Waybill',
    accessorKey: 'order.tracking_number',
    cell: TrackingCell,
  },
  {
    header: 'Origin',
    accessorKey: 'order.pickup_branch.name',
    cell: NACell,
  },
  {
    header: 'Sender',
    accessorKey: 'order.sender.full_name',
    cell: NACell,
  },
  {
    header: 'Destination',
    accessorKey: 'order.destination.name',
    cell: NACell,
  },

  {
    header: 'Receiver',
    accessorKey: 'order.receiver.full_name',
    cell: NACell,
  },

  {
    header: 'Pcs',
    accessorKey: 'order.piece',
    cell: NACell,
  },
  {
    header: 'Payment Method',
    accessorKey: 'order.payment_method.name',
    cell: NACell,
  },
  {
    header: 'Remarks',
    accessorKey: 'order.remarks',
    cell: ({ cell: { row, getValue } }) => (
      <button
        onClick={() => {
          setSelectedOrder(row?.original?.order.id);
          setOpenReviewModal(true);
        }}
      >
        {getValue()} Remarks
      </button>
    ),
  },
  // {
  //   header: 'Received',
  //   accessorKey: 'is_received',
  //   cell: ({ cell: { getValue } }) => {
  //     return (
  //       <>
  //         {getValue() ? (
  //           <svg
  //             width='24'
  //             height='24'
  //             viewBox='0 0 24 24'
  //             fill='none'
  //             xmlns='http://www.w3.org/2000/svg'
  //           >
  //             <path
  //               d='M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18457 2.99721 7.13633 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24015C11.8996 1.76491 14.1003 1.98234 16.07 2.86M22 4L12 14.01L9.00001 11.01'
  //               stroke='#26C943'
  //               stroke-width='2'
  //               stroke-linecap='round'
  //               stroke-linejoin='round'
  //             />
  //           </svg>
  //         ) : (
  //           <svg
  //             width='24'
  //             height='24'
  //             viewBox='0 0 24 24'
  //             fill='none'
  //             xmlns='http://www.w3.org/2000/svg'
  //           >
  //             <path
  //               d='M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'
  //               stroke='red'
  //               stroke-width='2'
  //               stroke-linecap='round'
  //               stroke-linejoin='round'
  //             />
  //           </svg>
  //         )}
  //       </>
  //     );
  //   },
  // },
];
